var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 84000 56000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h84000v56000H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#001489",
    d: "M0 0h84000v16800H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a44",
    d: "M0 39200h84000v16800H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42000 17696a784 784 0 0 1 698 425c1660 198 2533 1400 2837 2798 355 1634-21 3856-1174 6189l4429 5877a16016 16016 0 0 0 697-347l1628 3446a19824 19824 0 0 1-18230 0l1628-3446a16016 16016 0 0 0 697 347l4429-5877c-1153-2333-1529-4555-1174-6189 304-1398 1177-2600 2837-2798a784 784 0 0 1 698-425zm1754 8606c898-2005 1190-3906 906-5163-251-1112-814-1938-1932-2114v2871l1400 1400h-1120v2016zm-2482-7277c-1118 176-1681 1002-1932 2114-284 1257 8 3158 906 5163l746-990v-2016h-1120l1400-1400zm-6216 15087-479 1012 775-208zm-390 1452a18592 18592 0 0 0 1080 425l-239-650zm1763-152 1005-318-289-648a16688 16688 0 0 1-1228-426zm1188 94-1033 327 179 486a18592 18592 0 0 0 1370 346zm1116 440 1107-454-265-501a16688 16688 0 0 1-1385-264zm1318-56-1136 465 220 495a18592 18592 0 0 0 1516 173zm1116 314 1381-722-200-318a16688 16688 0 0 1-1761-56zm1622-342-1412 738 248 468a18592 18592 0 0 0 1890-58zm1159 262 1086-746-315-433a16688 16688 0 0 1-1408 171zm1350-384-1110 763 257 407a18592 18592 0 0 0 1514-264zm1010-41 904-802-369-447a16688 16688 0 0 1-1214 319zm1190-457-925 821 268 368a18592 18592 0 0 0 1306-405zm922-203 613-739-267-565a16688 16688 0 0 1-1069 430zm825-292-534 643 267 323a18592 18592 0 0 0 602-256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/ls.8f0471e088cbe976033fff49d37deaf0.svg";
export { ForwardRef as ReactComponent };